import React, { useState, useCallback } from 'react'
import Grid from '@mui/material/Grid'
import {
  FormControlLabel,
  MenuItem,
  Select
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import DateFnsUtils from '@date-io/date-fns'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import RoomIcon from '@mui/icons-material/Room'
import AddIcon from '@mui/icons-material/Add'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import Checkbox from '@mui/material/Checkbox'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import './flights.css'
import { getAuth } from '../../../utility/apiConfig'
import { API_BASE_URL } from '../../../utility/apiConstants'
import { useDispatch } from 'react-redux'
import { airports } from '../../../services/airportList'
import { depVali, fromVali, toVali } from './flightSearchValidation'
import { stringToDate } from '../../../core/helper'
import { useHistory } from 'react-router'
import flightSearchReducers from '../../../store/flights/reducers/flightSearchReducers'
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  }
}))

// const filterOptions = createFilterOptions({
//   ignoreCase:true,
//   limit:10,
//   matchFrom: 'any',
//   stringify: (option) => option.airport_code + option.airport_name + option.airport_city + option.country
// });

const filterOptions = (options, state) => {
  const { inputValue } = state

  if (!inputValue) {
    return options.slice(0, 10)
  }
  const arr = airports.filter((item) => {
    return item.airport_code.toLowerCase() === inputValue.toLowerCase()
  })

  if (arr && arr.length > 0) {
    return arr
  } else {
    const cityArr = airports.filter((item) => {
      return item.airport_city.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    })
    return cityArr && cityArr.length > 0 ? cityArr.slice(0, 20) : []
  }
}
function MultiCity () {
  const classes = useStyles()
  const dispatch = useDispatch(flightSearchReducers)
  const history = useHistory()

  const [showMore, setShowMore] = useState(false)
  const [depDate, setDepDate] = useState(new Date())
  const [classType, setClassType] = useState('Economy')
  const [open, setOpen] = useState(false)

  const [prefAirline, setprefAirline] = useState([])
  const [prefAirValue, setPrefAirValue] = useState(null)
  const [prefAirInValue, setPrefAirInValue] = useState('')
  const [continueTo, setContinueTo] = useState(true)

  const [showPassClass, setShowPassClass] = useState(false)
  const [showTravellerCount, setShowTravellerCount] = useState(false)
  const [showPassClassBtn, setShowPassClassBtn] = useState(true)

  const togglePassClass = () =>{
    setShowPassClass(!showPassClass)
  }

  const getTavellerCount = () => {
    setShowPassClassBtn(false)
    setShowTravellerCount(true)
    setShowPassClass(false)

  }

  const [multiCitites, setMultiCitites] = useState({
    trip_type: 'multicity',
    from: [],
    from_loc_id: [],
    to: [],
    to_loc_id: [],
    depature: [],
    adult: 1,
    child: 0,
    infant: 0,
    nonStop: false,
    search_flight: 'search',
    v_class: 'Economy',
    carrier: []
  })

  const [multiCity, setMultiCity] = useState([{
    from: '',
    from_loc_id: '',
    to: '',
    to_loc_id: '',
    depature: moment().add(1,'days'),
    fromValue:null,
    toValue:null,
    ferror: '',
    terror: '',
    derror: '',
    isOpenDep: ''
  }, {
    from: '',
    from_loc_id: '',
    to: '',
    to_loc_id: '',
    depature: '',
    fromValue: null,
    toValue: null,
    ferror: '',
    terror: '',
    derror: '',
    isOpenDep: ''
  }])

  const handleRemoveClick = (id) => {

    const list = [...multiCity]
    list.splice(id, 1)
    setMultiCity(list)
  }

  const handleAddClick = () => {
    setMultiCity([...multiCity, {
      from: '',
      from_loc_id: '',
      to: '',
      to_loc_id: '',
      depature: moment().add(1,'days').format("DD-MM-yy"),
      fromValue: null,
      toValue: null,
      ferror: '',
      terror: '',
      derror: '',
      isOpenDep: ''
    }])
  }

  const onClickAdult = (type) => {
    if (type === 'increment') {
      if (multiCitites.adult < 9) {
        setMultiCitites({
          ...multiCitites,
          adult: multiCitites.adult + 1,
          child: 0,
          infant: 0
        })
      }
    } else {
      if (multiCitites.adult > 1) {
        setMultiCitites({
          ...multiCitites,
          adult: multiCitites.adult - 1,
          child: 0,
          infant: 0
        })
      }
    }
  }

  const onClickChild = (type) => {
    if (type === 'increment') {
      if (multiCitites.child < (9 - multiCitites.adult)) {
        setMultiCitites({
          ...multiCitites,
          child: multiCitites.child + 1
        })
      }
    } else {
      if (multiCitites.child > 0) {
        setMultiCitites({
          ...multiCitites,
          child: multiCitites.child - 1
        })
      }
    }
  }

  const onClickInfants = (type) => {
    if (type === 'increment') {
      if (multiCitites.infant < multiCitites.adult) {
        setMultiCitites({
          ...multiCitites,
          infant: multiCitites.infant + 1
        })
      }
    } else {
      if (multiCitites.infant > 0) {
        setMultiCitites({
          ...multiCitites,
          infant: multiCitites.infant - 1
        })
      }
    }
  }

  const onClickNonStop = () => {
    setMultiCitites({
      ...multiCitites,
      nonStop: !multiCitites.nonStop
    })
  }

  const onClickStudentFare = () => {
    setMultiCitites({
      ...multiCitites,
      studentFare: !multiCitites.studentFare
    })
  }

  const showMoreToggle = () => {
    setShowMore(!showMore)
  }

  const handleClassChange = (event) => {
    setClassType(event.target.value)
    setMultiCitites({
      ...multiCitites,
      v_class: event.target.value
    })
  }

  const handleClassClose = () => {
    setOpen(false)
  }

  const handleClassOpen = () => {
    setOpen(true)
  }

  const searchAirline = useCallback(
    (search) => {
      getAuth(API_BASE_URL + 'data/get_airline/' + search, null)
        .then((response) => {
          let newOptions = []
          if (response.data.status) {
            newOptions = [...newOptions, ...(response.data.data)]
          }
          setprefAirline(newOptions)
        }).catch((error) => {
        })
    }
  )

  const handleMulticitySearch = () => {
    const list = [...multiCity]

    list.map((city, index) => {
      const fromEr = fromVali(city.from, city.to)
      const toEr = toVali(city.to, city.from)
      const depEr = depVali(city.depature)

      list[index].ferror = fromEr
      list[index].terror = toEr
      list[index].derror = depEr

      setMultiCity(list)
    })

    list.map((c, i) => {
      if (c.ferror || c.terror || c.derror) {
        setContinueTo(true)
      } else {
        setContinueTo(false)
      }
    })

    if (continueTo) {

    } else {
      setMultiCitites({
        ...multiCitites,
        from: [],
        to: [],
        to_loc_id: [],
        from_loc_id: [],
        depature: []
      })

      const mm = { ...multiCitites }

      multiCity.map((value, index) => {
        if (value.from) {
          mm.from.splice(index, 0, value.from)
          mm.from_loc_id.splice(index, 0, value.from_loc_id)
          mm.to.splice(index, 0, value.to)
          mm.to_loc_id.splice(index, 0, value.to_loc_id)
          mm.depature.splice(index, 0, stringToDate(value.depature))
        }
      })

      setMultiCitites(mm)

      history.push({
        pathname: '/flight/search',
        state: multiCitites
      })
    }
  }

  return (
        <div>

             <Box>
                <form className={classes.root} noValidate autoComplete="off">

        {multiCity.map((values, id) => {
          return (
                    <>

          <Box className="search-wpr">
            <Grid container spacing={1} className="cntrowswp" key={id}>
              <Grid item md={3} xs={12} className="prstColl px-0 mob-input-border-r" d={id}>
                <Box textAlign="left" className="box-tlt box-input-w">
              
                  <span>From</span>
                  <Autocomplete
                    className="inputFieldLocation"
                    size="small"
                    id="free-solo-demo"
                    autoComplete
                    includeInputInList
                    filterSelectedOptions
                    value={values.fromValue}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        const list = [...multiCity]
                        list[id].from = newValue.airport_city + ' (' + newValue.airport_code + ')'
                        list[id].from_loc_id = newValue.origin
                        list[id].fromValue = newValue
                        list[id].ferror = ''
                        setMultiCity(list)
                      }
                    }}
                    options={airports}
                    filterOptions={filterOptions}
                    getOptionLabel={(option) => option.airport_city + " (" +option.airport_code + ")"}
                    renderOption={(props, option) => (
                      <li {...props}>
                        <Box className="searchsuggestionbox">
                            <Box className="flightdetails-code">
                            <Box className="cityfly">{option.airport_city}, {option.country}</Box>
                            <Box className="airportcode">{option.airport_code}</Box>
                            </Box>
                            <Box className="airport-name">{option.airport_name}</Box>
                        </Box>
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        margin="normal"
                        variant="outlined"
                        placeholder="Type atleast 3 letters"
                        className="inputFieldLocation"
                        name='from'
                        error={!!values.ferror}
                        helperText={values.ferror}
                        />
                    )}
                    />
                  </Box>
                </Grid>
                  {/* <Box className="swipebox_multicity">
                    <Box className="icoswipe"><img src={swipe} alt=""></img></Box>
                  </Box> */}
            
                <Grid item md={3} xs={12} className="prstColl px-0 d-flex mob-input-border-r" id={id}>
                  <span className='border-right div-border-right'></span>
                  <Box textAlign="left" className="box-tlt box-input-w">
                  <span>To</span>
                    <Autocomplete
                      className="inputFieldLocation"
                      size="small"
                      id="free-solo-demo"
                      name="to"
                      autoComplete
                      includeInputInList
                      filterSelectedOptions
                      options={airports}
                      filterOptions={filterOptions}
                      getOptionLabel={(option) => option.airport_city + " (" +option.airport_code + ")"}
                      renderOption={(props, option) => (
                        <li {...props}>
                          <Box className="searchsuggestionbox">
                              <Box className="flightdetails-code">
                              <Box className="cityfly">{option.airport_city}, {option.country}</Box>
                              <Box className="airportcode">{option.airport_code}</Box>
                              </Box>
                              <Box className="airport-name">{option.airport_name}</Box>
                          </Box>
                          </li>
                      )}
                      renderInput={(params) => (
                          <TextField
                          {...params}
                          margin="normal"
                          variant="outlined"
                          placeholder="Type atleast 3 letters"
                          className="inputFieldLocation"
                          name='to'
                          error={!!values.terror}
                          helperText={values.terror}
                          />
                      )}
                          value={values.toValue}
                          onChange={(event, newValue) => {
                            if (newValue) {
                              const list = [...multiCity]
                              list[id].to = newValue.airport_city + ' (' + newValue.airport_code + ')'
                              list[id].to_loc_id = newValue.origin
                              list[id].toValue = newValue
                              list[id].terror = ''
                              setMultiCity(list)
                            }
                          }}
                      />
                  </Box>
                </Grid>

                <Grid item md={3} xs={12} className="prstColl d-flex px-0 mob-input-border-r">
                  <span className='border-right div-border-right'></span>
                    <Box textAlign="left" className="box-tlt pt-2">
                      <span>departure date</span>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                              open={values.isOpenDep}
                              className="inputDate"
                              size="small"
                              disableToolbar
                              variant="inline"
                              inputVariant="outlined"
                              format="EE, dd MMM&#8217;yy"
                              margin="normal"
                              id="date-picker-inline"
                              disablePast
                              autoOk
                              name="depature"
                              placeholder="Depature Date"
                              value={values.depature ? values.depature : null}
                              onChange={(e) => {
                                const list = [...multiCity]
                                list[id].depature = e
                                list[id].derror = ''

                                list[id].isOpenDep = false

                                setMultiCity(list)
                              }}
                              KeyboardButtonProps={{
                                onFocus: e => {
                                  const list = [...multiCity]
                                  list[id].isOpenDep = true
                                  setMultiCity(list)
                                }
                              }}

                              PopoverProps={{
                                disableRestoreFocus: true,
                                onClose: () => {
                                  const list = [...multiCity]
                                  list[id].isOpenDep = false
                                  setMultiCity(list)
                                }
                              }}
                            InputProps={{
                              onFocus: () => {
                                const list = [...multiCity]
                                list[id].isOpenDep = true
                                setMultiCity(list)
                              }
                            }}
                              error={!!values.derror}
                              helperText={values.derror}
                          />
                      </MuiPickersUtilsProvider>
                    </Box>
                  </Grid>
                  { id < 1 && (
                  <Grid item md={3} xs={10} className="prstColl d-flex px-0 mob-input-border-r">
                      <span className='border-right div-border-right'></span>
                      <Box textAlign="left" className="box-tlt pt-2">
                          <span>Passengers & Class</span>
                            <h6 onClick={togglePassClass} className='trav-txt'><span className='trav-count'>{multiCitites.adult + multiCitites.child + multiCitites.infant}</span> Travellers <p className='class-txt'>{multiCitites.v_class}</p></h6>
                            {showPassClass ? (
                              <Box className='passclass-box'>
                                <Grid container spacing={1} className="rowGap btnGroup">
                                  <Grid item md={12}>
                                    <Box>
                                      <Box textAlign="left" className="box-tlt">
                                        adults (12 Yrs +)
                                      </Box>
                                      <ButtonGroup
                                        size="small"
                                        aria-label="small outlined button group"
                                        className="btnGroup"
                                      >
                                        <Button className="btnGroup" onClick={() => onClickAdult('decrement')}>-</Button>
                                        <Button className="btnGroup">
                                          {multiCitites.adult}
                                        </Button>
                                        <Button className="btnGroup" onClick={() => onClickAdult('increment')}>+</Button>
                                      </ButtonGroup>
                                    </Box>
                                  </Grid>
                                  <Grid item md={12}>
                                    <Box>
                                      <Box textAlign="left" className="box-tlt">
                                        child (2 yrs - 12 Yrs)
                                      </Box>
                                      <ButtonGroup
                                        size="small"
                                        aria-label="small outlined button group"
                                        className="btnGroup"
                                      >
                                        <Button className="btnGroup" onClick={() => onClickChild('decrement')}>-</Button>
                                        <Button className="btnGroup">
                                        {multiCitites.child}
                                        </Button>
                                        <Button className="btnGroup" onClick={() => onClickChild('increment')}>+</Button>
                                      </ButtonGroup>
                                    </Box>
                                  </Grid>
                                  <Grid item md={12}>
                                    <Box>
                                      <Box textAlign="left" className="box-tlt">
                                        infant (Below 2 Yrs)
                                      </Box>
                                      <ButtonGroup
                                        size="small"
                                        aria-label="small outlined button group"
                                        className="btnGroup"
                                      >
                                        <Button className="btnGroup" onClick={() => onClickInfants('decrement')}>-</Button>
                                        <Button className="btnGroup">
                                          {multiCitites.infant}
                                        </Button>
                                        <Button className="btnGroup" onClick={() => onClickInfants('increment')}>+</Button>
                                      </ButtonGroup>
                                    </Box>
                                  </Grid>
                                  <Grid item md={12}>
                                    <Box className="divSet">
                                      <Box textAlign="left" className="box-tlt">
                                        Class
                                      </Box>
                                      <Select
                                        labelId="demo-controlled-open-select-label"
                                        id="demo-controlled-open-select"
                                        open={open}
                                        onClose={handleClassClose}
                                        onOpen={handleClassOpen}
                                        value={classType}
                                        onChange={handleClassChange}
                                        variant="outlined"
                                        className="ClassSelector"
                                      >
                                        <MenuItem className="items-list" selected={true} value="Economy">
                                          Economy
                                        </MenuItem>
                                        <MenuItem className="items-list" value="Premium Economy">
                                          Premium Economy
                                        </MenuItem>
                                        <MenuItem className="items-list" value="Business">
                                          Business
                                        </MenuItem>
                                      </Select>
                                    </Box>
                                  </Grid>
                                  <Grid item md={6} className="px-2 pt-2">
                                    <Button
                                    variant="contained"
                                    color="primary"
                                    className=""
                                    onClick={getTavellerCount}
                                    >
                                      Apply
                                    </Button>
                                  </Grid>
                                </Grid>
                              </Box>
                              ) : "" }
                           </Box>
                        </Grid>
                     
                  )}

                  { id > 1 && (
                    <Grid item md={3} xs={2} className="prstColl d-flex px-0">
                      <span className='border-right div-border-right'></span>
                      <Box textAlign="left" className="box-tlt pt-2">
                        <HighlightOffIcon className="times-icon"
                          id={id}
                          onClick={() => handleRemoveClick(id)}
                        />
                      </Box>
                    </Grid>
                  )}

              </Grid>
            </Box>
              </>
          )
        })}

          {/* {multiCity.map((value, id) => {

              return(
                    <>
                      <Grid container spacing={1} className="formRow">

                            <MultiComponent
                               id={id}
                               multiCity={value}
                            />

                              { id > 1 &&(
                              <HighlightOffIcon className="times-icon"
                                id={id}
                                onClick={()=>handleRemoveClick(id)}
                              />
                              )}

                      </Grid>
                    </>
                )
                })} */}

              { multiCity.length < 5 && (
                  <Grid container spacing={0}>
                  <Grid item md={5}></Grid>
                  <Grid items md={5}></Grid>

                  <Grid item md={2} className="px-2">
                    <Button
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      className="addon-btn"
                      onClick={handleAddClick}
                    >
                      Add City
                    </Button>
                  </Grid>
                </Grid>
              )}

                  <Grid container spacing={1}>
                    <Grid item md={12}>
                      <Box className="lineBar"></Box>
                    </Grid>
                  </Grid> 

                  <Grid container spacing={0}>
                    <Grid item lg={3}>
                      <FormControlLabel
                        className="nonstop-tlt"
                        control={
                          <Checkbox
                            checked={multiCitites.nonStop}
                            onChange={onClickNonStop}
                            name="nonStop"
                          />
                        }
                        label="Non-Stop"
                        color="secondary"
                      />

                    </Grid>

                    {/* <Grid item lg={4}>
                      <div className="checkbox-tag">
                      <FormControlLabel
                className="nonstop-tlt"
                control={
                  <Checkbox
                    checked={multiCitites.studentFare}
                    onChange={onClickStudentFare}
                    name="studentFare"
                  />
                }
                label="Student fare"
                color="secondary"
              />
                      </div>
                    </Grid> */}

                    <Grid item md={4}>
                      <div className="moreOption">

                        <div className="tlt-btn-more" onClick={showMoreToggle}>
                          <span>
                            <ArrowDropDownIcon
                              className="icoarrow"
                              fontSize="large"
                            />
                          </span>
                          <span>Show more options</span>
                        </div>

                        {showMore && (
                          <div className="option-items">
                          <div className="tlt-mini-tag">Preferred airline</div>
                          <Autocomplete
                            className="inputField"
                            // startIcon={<RoomIcon />}
                            size="small"
                            id="free-solo-demo"
                            freeSolo
                            autoComplete
                            includeInputInList
                            filterSelectedOptions
                            options={prefAirline}
                            getOptionLabel={(option) => option.label}
                            renderOption={(props, option) => (
                              <li {...props}>
                               <Box className="searchsuggestionbox">
                                   <Box className="airport-name">{option.label}</Box>
                               </Box>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                              {...params}
                              margin="normal"
                              variant="outlined"
                              placeholder="Type atleast 3 letters"
                              className="inputFieldLocation"
                              />
                            )}

                            filterOptions={(x) => x}
                            value={prefAirValue}
                            onChange={(event, newValue) => {
                              setprefAirline(newValue ? [newValue, ...prefAirline] : prefAirline)
                              setPrefAirValue(newValue)
                              if (newValue) {
                                const c = [newValue.value]
                                setMultiCitites({
                                  ...multiCitites,
                                  carrier: c
                                })
                              }
                            }}
                            onInputChange={(event, newInputValue) => {
                              if (newInputValue) {
                                setPrefAirInValue(newInputValue)
                                searchAirline(newInputValue)
                              }
                            }}
                          />
                        </div>
                        )}
                      </div>
                    </Grid>
                    <Grid item md={3}></Grid>
                    <Grid item md={2} xs={6} >
                        <Button
                          variant="contained"
                          color="primary"
                          className="btnSend"
                          onClick={handleMulticitySearch}
                        >
                          Search Flight
                        </Button>
                      </Grid>
                    </Grid>

                </form>
              </Box>
        </div>
  )
}

export default MultiCity
